import React from "react";
import { ScrollToTop, TooltipProvider } from "@/components";
import { Toaster } from "react-hot-toast";
import { AppRoutes } from "@/routes";
import type { JSX } from "react";

/**
 * Main application component that handles routing and base structure
 * @component
 * @returns {JSX.Element} The App component with its routing structure
 */
export const App: React.FC = (): JSX.Element => {
  return (
    <>
      <Toaster position="top-center" toastOptions={{ duration: 1500 }} />
      <ScrollToTop />
      <TooltipProvider delayDuration={300} skipDelayDuration={0}>
        <AppRoutes />
      </TooltipProvider>
    </>
  );
};

export default App;
